var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPartnerIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 257,
    height: 134,
    viewBox: "0 0 257 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.1295 55.1913V72.2613C41.1295 77.434 38.5432 80.0206 33.3704 80.0206H8.54134C3.36859 80.0206 0.782227 77.434 0.782227 72.2613V47.4322C0.782227 42.2594 3.36859 39.6731 8.54134 39.6731H41.1295V48.984H10.0931V70.7094H31.8186V64.5022H19.404V55.1913H41.1295Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4474 48.984H53.722V55.1913H75.4474V48.984ZM57.7568 64.5022H53.722V80.0206H44.4111V47.4322C44.4111 42.2594 46.9975 39.6731 52.1702 39.6731H76.9994C82.1719 39.6731 84.7585 42.2594 84.7585 47.4322V56.7431C84.7585 61.9158 82.1719 64.5022 76.9994 64.5022H71.4128L86.9306 80.0206H73.2746L57.7568 64.5022Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3522 64.5022V70.7094H128.388V80.0206H95.8002C90.6276 80.0206 88.041 77.434 88.041 72.2613V47.4322C88.041 42.2594 90.6276 39.6731 95.8002 39.6731H128.388V48.984H97.3522V55.1913H128.388V64.5022H97.3522Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M140.98 64.5022V70.7094H172.017V80.0206H139.429C134.256 80.0206 131.67 77.434 131.67 72.2613V47.4322C131.67 42.2594 134.256 39.6731 139.429 39.6731H172.017V48.984H140.98V55.1913H172.017V64.5022H140.98Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M206.336 48.984H184.61V80.0206H175.299V47.4322C175.299 42.2594 177.885 39.6731 183.058 39.6731H207.887C213.06 39.6731 215.646 42.2594 215.646 47.4322V80.0206H206.336V48.984Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1295 92.8539V102.165H10.0931V108.372H33.3704C38.5432 108.372 41.1295 110.958 41.1295 116.131V125.442C41.1295 130.615 38.5432 133.201 33.3704 133.201H0.782227V123.891H31.8186V117.683H8.54134C3.36859 117.683 0.782227 115.097 0.782227 109.924V100.613C0.782227 95.4405 3.36859 92.8539 8.54134 92.8539H41.1295Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4474 102.165H53.722V108.372H75.4474V102.165ZM53.722 117.683V133.201H44.4111V100.613C44.4111 95.4405 46.9975 92.8539 52.1702 92.8539H76.9994C82.1719 92.8539 84.7586 95.4405 84.7586 100.613V109.924C84.7586 115.097 82.1719 117.683 76.9994 117.683H53.722Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3522 120.787V133.201H88.041V100.613C88.041 95.4405 90.6276 92.8539 95.8002 92.8539H120.629C125.802 92.8539 128.388 95.4405 128.388 100.613V133.201H119.077V120.787H97.3522ZM119.077 111.475V102.165H97.3522V111.475H119.077Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M140.98 102.165V123.891H172.017V133.201H139.429C134.256 133.201 131.67 130.615 131.67 125.442V100.613C131.67 95.4405 134.256 92.8539 139.429 92.8539H172.017V102.165H140.98Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M184.61 117.683V123.891H215.646V133.201H183.058C177.885 133.201 175.299 130.615 175.299 125.442V100.613C175.299 95.4405 177.885 92.8539 183.058 92.8539H215.646V102.165H184.61V108.372H215.646V117.683H184.61Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_315_1691)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.447 19.6516C256.447 30.4169 247.72 39.1441 236.955 39.1441C226.189 39.1441 217.462 30.4169 217.462 19.6516C217.462 8.88618 226.189 0.159058 236.955 0.159058C247.72 0.159058 256.447 8.88618 256.447 19.6516ZM220.986 19.6516C220.986 28.471 228.135 35.6206 236.955 35.6206C245.774 35.6206 252.924 28.471 252.924 19.6516C252.924 10.8321 245.774 3.68254 236.955 3.68254C228.135 3.68254 220.986 10.8321 220.986 19.6516Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_315_1691)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.955 18.4332L234.519 15.9966V11.5296H239.392V15.9966L236.955 18.4332ZM240.61 22.0881L238.173 19.6515L240.61 17.2149H245.077V22.0881H240.61ZM228.833 22.0881V17.2149H233.3L235.736 19.6515L233.3 22.0881H228.833ZM234.519 27.7734V23.3063L236.955 20.8698L239.392 23.3063V27.7734H234.519Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_315_1691",
    x: 217.462,
    y: 0.159058,
    width: 38.9854,
    height: 38.985,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.655949
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_315_1691"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_315_1691",
    x: 228.833,
    y: 11.5296,
    width: 16.2441,
    height: 16.2438,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.655949
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_315_1691"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerIcon1);
export default __webpack_public_path__ + "static/media/partnerIcon1.faddc67a0c6186af60d009f5d1ac5012.svg";
export { ForwardRef as ReactComponent };